<template>
  <section class="shareCommunity">
    <img src="https://cdn.gelonghui.com/webActive/img_community_content.png"
         alt />
    <div class="container">
      <img src="https://cdn.gelonghui.com/webActive/img_community_wechatbg.png"
           alt />
      <p v-clipboard="'GuruClub_88'"
         @success="onCopy"
         @error="onError"
         class="wechatAdd">GuruClub_88</p>
    </div>
    <button @click="gomember">加入会员</button>
  </section>
</template>

<script>
// import axios from "axios"
export default {
  name: "shareCommunity",
  data() {
    return {
      val: ""
    };
  },
  created() { },
  mounted() {
    document.title = "会员社群";
    window.wechatagain = {
      title: "格隆汇会员专享社群",
      content: "和格隆汇研究团队一起交流投资经验",
      image: "https://cdn.gelonghui.com/webActive/wechat_shequn.png"
    };
  },
  methods: {
    onCopy: function (e) {
      this.$toast("复制成功~");
    },
    onError: function (e) {
      this.$toast("复制失败~");
    },
    gomember() {
      window.location.href =
        "https://www.gelonghui.com/app/device_redirect.html";
    }
  }
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
}

.shareCommunity {
  position: relative;
  padding-bottom: 82px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  > img {
    width: 100%;
  }
  .container {
    width: 100%;
    position: absolute;
    top: 330px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
    }
    .wechatAdd {
      position: absolute;
      top: 74px;
      left: 260px;
      font-size: 34px;
      color: rgba(115, 81, 36, 1);
      font-weight: 600;
    }
  }
  > button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    border: none;
    outline: none;
    text-align: center;
    background: rgba(255, 224, 170, 1);
    font-size: 30px;
    font-weight: 600;
    color: rgba(120, 72, 47, 1);
    line-height: 88px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/member-share/shareCommunity.vue